var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIsotype(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5B49FE",
    d: "M3.106 0h24.927a3.106 3.106 0 0 1 3.106 3.106V27.95a3.106 3.106 0 0 1-3.106 3.106H3.106A3.106 3.106 0 0 1 0 27.95V3.106A3.106 3.106 0 0 1 3.106 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0BCC8A",
    d: "M21.801 18.646H46.73a3.106 3.106 0 0 1 3.106 3.106v24.844a3.106 3.106 0 0 1-3.106 3.106H21.8a3.106 3.106 0 0 1-3.105-3.106V21.752a3.106 3.106 0 0 1 3.105-3.106z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD348",
    d: "M3.106 18.646h24.927a3.106 3.106 0 0 1 3.106 3.106v24.844a3.106 3.106 0 0 1-3.106 3.106H3.106A3.106 3.106 0 0 1 0 46.596V21.752a3.106 3.106 0 0 1 3.106-3.106z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2280",
    d: "M21.801 0H46.73a3.106 3.106 0 0 1 3.106 3.106V27.95a3.106 3.106 0 0 1-3.106 3.106H21.8a3.106 3.106 0 0 1-3.105-3.106V3.106A3.106 3.106 0 0 1 21.8 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsotype);
export default __webpack_public_path__ + "static/media/isotype.bb54bc5204a91de233a2b64c6a96168b.svg";
export { ForwardRef as ReactComponent };